<template>
    <div class="setting-content--section">
        <b-form class="form-horizontal" @submit="onSubmit">
            <p>
                You can download all your Gekko data at any time. The resulting ZIP file will contain all your invoices,
                costs, and overviews of both in (Excel compatible) CSV format. Your accounts will remain available
                online.
            </p>
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <label>Select a year</label>
                        <b-form-select v-model="form.selectedYear" :options="optionsYear">
                        </b-form-select>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <label>Select a quarter</label>
                        <b-form-select v-model="form.selectedQuarter" :options="optionsQuarter">
                        </b-form-select>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <GekkoButton :text="$gettext('Download')" icon="fa-solid fa-download" type="submit" :disabled="isButtonDisabled" />
                    </div>
                </b-col>
            </b-row>
            <div v-if="isButtonDisabled">{{ $gettext("Your download is being prepared. You will receive an email when it is done.") }}</div>
        </b-form>
    </div>
</template>

<script>
import CompanyService from "@/store/services/company.service.js";
import GekkoButton from "@/components/GekkoButton";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "DownloadData",
    components: { GekkoButton },
    mixins: [settingsPageSetup],
    data() {
        return {
            buttonDisabled: false,
            pageSettings: {
                title: this.$gettext("Download your data"),
                showCompanyPicker: true
            },
            company: null,
            optionsYear: [],
            optionsQuarter: [
                { value: null, text: 'All' },
                { value: 'Q1', text: 'Q1' },
                { value: 'Q2', text: 'Q2' },
                { value: 'Q3', text: 'Q3' },
                { value: 'Q4', text: 'Q4' },
            ],
            form: {
                selectedYear: null,
                selectedQuarter: null,
            }
        }
    },
    created() {
        this.buttonDisabled = this.$cookies.get("disable_download_data_button") === "true";
        var vm = this;
        CompanyService.financiallyActiveYears({ company: window.company_id }).then(function (response) {
            var raw = response.data;
            var processed = [];

            var firstOption = { value: null, text: 'All' };
            processed.push(firstOption);
            raw.forEach(element => {
                processed.push({ value: element, text: element });
            });

            vm.optionsYear = processed;
        });
    },
    mounted() {
    },
    methods: {
        onSubmit(event) {
            this.buttonDisabled = true;
            event.preventDefault();
            CompanyService.downloadData(window.company_id, { year: this.form.selectedYear, quarter: this.form.selectedQuarter }).then((response) => {
                var expiry_date = new Date();
                expiry_date.setSeconds(expiry_date.getSeconds() + 10*60);
                this.$cookies.set("disable_download_data_button", true, expiry_date)
                switch (response.status) {
                    case 200:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Data downloaded"),
                            text: this.$gettext("Your downloaded data will be sent in an e-mail. This might take a few minutes."),
                            duration: 4
                        });
                        break;
                    case 204:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("No data available for download"),
                            text: this.$gettext("You don't have any data to be downloaded. Try adding invoices, costs, suppliers or trips."),
                            variant: "error",
                            duration: 4
                        });
                        break;
                    case 500:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Error downloading data"),
                            text: this.$gettext("Something went wrong when trying to fetch and download your data. Please try again later."),
                            variant: "error",
                            duration: 4
                        });
                        break;
                }
            }).catch((response) => {
                if (response.status === 496) {
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Error downloading data"),
                        text: this.$gettext("You do not have access to this data."),
                        variant: "error",
                        duration: 4
                    });
                }
            })
        },
    },
    computed:{
        isButtonDisabled(){
            return this.buttonDisabled || this.$cookies.get("disable_download_data_button") === "true";
        }
    }
}
</script>

<style scoped>
div {
    white-space: pre-wrap;
    max-width: 90%;
}

@media(max-width: 840px) {
    div {
        max-width: 100%;
    }
}
</style>